import classNames from 'classnames';

import Button from '@/components/button';
import { modalStore } from '@/stores/modal';
import { openInBrowser } from '@/utils/apk';
import { isInApk } from '@/utils/apk';
import Storage from '@/utils/Storage';

import styles from './styles.module.less';

const SubscribelModal = () => {
  const url = Storage.get('subscribe_page');

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        {url && url.includes('play.google.cov.') ? (
          <>
            <div>Click on [Accept] to open the </div>
            <div>notification and receive a $10 bonus.</div>
          </>
        ) : (
          <>
            <div>The latest bonuses and activities to</div>
            <div>earn money, don&apos;t miss out.</div>
          </>
        )}
      </div>
      <div className={styles.btns}>
        <Button
          className={classNames(styles.btn, styles.left)}
          onClick={() => {
            modalStore.closeModal('subscribe-modal');
          }}
        >
          Reject
        </Button>
        <Button
          className={classNames(styles.btn, styles.right)}
          onClick={() => {
            modalStore.closeModal('subscribe-modal');
            isInApk() ? openInBrowser(url) : window.open(url);
          }}
        >
          Accept
        </Button>
      </div>
    </div>
  );
};

export default SubscribelModal;
